import React, { Component, Fragment } from 'react'
import Header from 'components/Header'
import CategoryNav from 'components/CategoryNav'
import Category from 'components/Category'
import Section from 'components/Section'
import SearchResults from 'components/SearchResults'
import TableBreadcrumbs from './TableBreadcrumbs'

import { bindActionCreators } from 'redux'

import { Route, Redirect } from 'react-router-dom'
import { fetchArticleFeedbackReport } from 'modules/reports/articleFeedback/actions'

import MMModal from 'components/MMModal'

import { connect } from 'react-redux'
import { getCategoryById, getSection, getCategories, getFetchCategoriesLoaded, getArticleIDsByPage } from 'modules/knowledgebase/selectors'
import { getRenderSearchTable } from 'modules/search/selectors'

import './style.css'

class Home extends Component {
  state = {
    categoryName: '',
    articleIDs: []
  }
  
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.articleIDs.length !== prevState.articleIDs.length && nextProps.articleIDs.length > 0) {
      nextProps.actions.fetchArticleFeedbackReport({articleIDs: nextProps.articleIDs})
    }
    
    return {
      articleIDs: nextProps.articleIDs,
      categoryName: nextProps.category ? `${nextProps.category.name} /` : ''
    }
  }
  
  render() {
    const { categoriesFetchStatus, match, section, category, categories, renderSearchTable } = this.props
    const { categoryName } = this.state
    
    if (!categoriesFetchStatus) return null
    return (
      <div className="knowledgebase-home-page">
        {!this.props.match.params.categoryId &&
          <Redirect exact from='/category' to={`/category/${categories[0].id}`}/>
        }
        <Header {...this.props}/>
        <MMModal />
        <div className="knowledgebase-home-page-content-area">
          <CategoryNav match={match} />
          <div className="knowledgebase-table-area">
            {category &&
              <TableBreadcrumbs
                name={categoryName}
                id={category.id}
                section={section}
              />
            }
            {!renderSearchTable &&
              <Fragment>
                <Route exact path="/category/:categoryId" render={props => <Category {...props} />}/>
                <Route exact path="/category/:categoryId/:sectionId" render={props => <Section {...props} />}/>
              </Fragment>
            }
            {!!renderSearchTable && <SearchResults/>}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  categoriesFetchStatus: getFetchCategoriesLoaded(state),
  
  section: getSection(state, {
    sectionId: parseInt(props.match.params.sectionId, 10)
  }),
  
  category: getCategoryById(state, {
    categoryId: parseInt(props.match.params.categoryId, 10)
  }),
  
  categories: getCategories(state),
  renderSearchTable: getRenderSearchTable(state),
  
  articleIDs: getArticleIDsByPage(state, {
    sectionId: parseInt(props.match.params.sectionId, 10),
    categoryId: parseInt(props.match.params.categoryId, 10)
  })
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    fetchArticleFeedbackReport
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Home)
